export default __webpack_public_path__ + "static/media/01-bauble.d951e5e7.svg";